import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import "../Css/loadingpage.css";

const LoadingPage = ({ onComplete }) => {
  const circleRef = useRef(null);
  const textRef = useRef(null);
  const codeRef1 = useRef(null);
  const codeRef2 = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      circleRef.current,
      { strokeDashoffset: 502 },
      {
        strokeDashoffset: 0,
        duration: 0.5, // Speed up the loading effect
        ease: "power2.out",
        onComplete: () => {
          setTimeout(onComplete, 300);
        },
      }
    );

    gsap.fromTo(
      textRef.current,
      { opacity: 0, scale: 0.8 },
      { opacity: 1, scale: 1, duration: 0.3, ease: "power2.out" }
    );

    // Animate code symbols (< > and </>) - Fading effect
    gsap.fromTo(
      [codeRef1.current, codeRef2.current],
      { opacity: 0, y: -10 },
      {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "power2.out",
        repeat: -1,
        yoyo: true,
      }
    );
  }, [onComplete]);

  return (
    <div className="loading-container">
      <svg width="200" height="200" viewBox="0 0 200 200">
        {/* Animated Progress Circle */}
        <circle
          ref={circleRef}
          cx="100"
          cy="100"
          r="80"
          stroke="url(#goldenGradient)"
          strokeWidth="5"
          fill="none"
          strokeDasharray="502"
          strokeDashoffset="502"
          strokeLinecap="round"
          transform="rotate(-90 100 100)"
        />
        {/* Gradient for Progress */}
        <defs>
          <linearGradient id="goldenGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#FFD700" />
            <stop offset="50%" stopColor="#B8860B" />
            <stop offset="100%" stopColor="#5A3E12" />
          </linearGradient>
        </defs>
      </svg>

      {/* Coding symbols <> </> */}
      <div ref={codeRef1} className="code-symbol" style={{ left: "35%" }}>
        {"< >"}
      </div>
      <div ref={codeRef2} className="code-symbola" style={{ right: "35%" }}>
        {"< />"}
      </div>

      {/* Gradient "DS" Text */}
      <div ref={textRef} className="ds-text">
        DS
      </div>
    </div>
  );
};

export default LoadingPage;
